export default [
  {
    title: "Merchant Management",
    customIcon: "LotterySVG",
    children: [
      {
        title: "All Merchant",
        route: "custom-merchant-list",
        path: "/custom-merchant/list",
      },
    ],
  },
];
